import {mapRecipeResponseToDetailedCardProps, RecipeDetailModel} from '@mfb/cookbook';
import {DetailedCardContextProps, IngredientGroup, IngredientType, Nutrition} from '@mfb/lego';

import {
  CarouselV2IngredientGroupResponse,
  CarouselV2NutritionResponse,
  CarouselV2RecipeResponse,
} from '../../contentful/recipeCarouselV2/utils/mapRecipeCarouselV2';

const toIngredientGroup = (group: CarouselV2IngredientGroupResponse): IngredientGroup => ({
  name: group.name ?? '',
  ingredients: (group.ingredients ?? []).map(i => ({
    ingredientType: (i.ingredientType ?? IngredientType.Other) as IngredientType,
    description: i.description ?? '',
    allergensContains: i.allergensContains ?? null,
    allergensMayContain: i.allergensMayContain ?? null,
  })),
});

const toNutrition = (info: Array<CarouselV2NutritionResponse> = []): Array<Nutrition> =>
  info.flatMap(n =>
    n.code && n.value !== undefined && n.value !== null
      ? [{code: n.code, label: n.label ?? '', value: n.value, unit: n.unit}]
      : []
  );

export const toRecipeDetailModel = (recipe: CarouselV2RecipeResponse): RecipeDetailModel => ({
  recipeNumber: recipe.recipeNumber ?? '',
  recipeVersion: recipe.recipeVersion ?? '',
  recipePartition: recipe.recipePartition ?? '',
  title: recipe.title ?? '',
  subtitle: recipe.subTitle ?? '',
  description: recipe.description ?? '',
  imageUrl: recipe.webLargeImageUrl ?? recipe.webImageUrl ?? '',
  numberOfServes: recipe.numberOfServesValue === undefined ? '' : String(recipe.numberOfServesValue),
  readyInTime: recipe.readyInTimeMinutes,
  consumption: recipe.consumption ?? '',
  composition: recipe.composition,
  tags: recipe.tags ?? [],
  badge: recipe.badge?.find(b => b.description)?.description ?? '',
  allergens: [],
  allergensContains: recipe.allergensContains ?? [],
  allergensMayContain: recipe.allergensMayContain ?? [],
  ingredientGroups: (recipe.ingredientGroups ?? []).map(toIngredientGroup),
  nutritionalInformation: toNutrition(recipe.nutritionalInformation),
  steps: [],
  surcharge: undefined,
  type: '',
  brand: '',
  recipeDocumentId: '',
  maximumQuantity: 0,
  recipeId: '',
  version: '',
  partitionKey: '',
});

export const mapRecipeDetail = (recipe: CarouselV2RecipeResponse): DetailedCardContextProps =>
  mapRecipeResponseToDetailedCardProps(toRecipeDetailModel(recipe), false);
